module.exports = __webpack_public_path__ + "3d333feda9d7dfa1cde991b63305c606.pdf";